import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  PatchAdminV1StoresStoreIdRedirectsIdBody,
  PostAdminV1StoresStoreIdRedirectsBody,
} from '@nucleus-commerce/api-client/admin';

import { redirectsApi } from '../api/redirects-api';

import { redirectKeys } from './redirect-keys';

/** 409 on `fromPath` for a duplicate, 422 on `toPath` for a self-target or a bad scheme. */
export function useCreateRedirect(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: PostAdminV1StoresStoreIdRedirectsBody) => redirectsApi.create(storeId, body),
    meta: { successMessage: 'redirects:toasts.created', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: redirectKeys.all(storeId) }),
  });
}

export function useUpdateRedirect(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: PatchAdminV1StoresStoreIdRedirectsIdBody }) =>
      redirectsApi.update(storeId, id, body),
    meta: { successMessage: 'redirects:toasts.updated', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: redirectKeys.all(storeId) }),
  });
}

export function useDeleteRedirect(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => redirectsApi.remove(storeId, id),
    meta: { successMessage: 'redirects:toasts.deleted', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: redirectKeys.all(storeId) }),
  });
}
